<template>
  <div>
    <div class="row">
      <div class="col">
        <h1>C# Class Modeller</h1>
      </div>
    </div>
    <BuildClass/>

    <footer>
      <hr>
      &copy;2021, Michael Gattuso
    </footer>
  </div>
</template>

<style>
  h1 {
    border-bottom: 2px solid #363636;
    padding-bottom: 5px;
    margin-top: 10px !important;
    margin-bottom: 20px !important;
  }
  footer {
    margin-top: 80px;
  }
</style>

<script>
// @ is an alias to /src
import BuildClass from '@/components/BuildClass.vue'

export default {
  name: 'Home',
  components: {
    BuildClass
  }
}
</script>
